import { useContext } from 'react';
import { EventScopeContext } from './EventScopeContext';
import type { EventScope } from '../core/EventScope';

export function useEventScope(): EventScope | null {
  return useContext(EventScopeContext);
}

export function useRequiredEventScope(): EventScope {
  const scope = useContext(EventScopeContext);
  if (!scope) {
    throw new Error(
      '[block-events] useRequiredEventScope called outside EventScopeProvider. ' +
        'Ensure a parent component provides an EventScope.',
    );
  }
  return scope;
}
